import { render } from "./commentsContainer.vue?vue&type=template&id=7bf40f15&scoped=true&ts=true"
import script from "./commentsContainer.vue?vue&type=script&lang=ts"
export * from "./commentsContainer.vue?vue&type=script&lang=ts"

import "./commentsContainer.vue?vue&type=style&index=0&id=7bf40f15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf40f15"]])

export default __exports__